module.exports = __webpack_public_path__ + "img/playstar.730b62fc.jpg";